/**
 * mcycle search page
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/6
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Step from '../step';
import ProductList from '../home/productList/index';
import { getProductByQuery } from '../../actions/search';

class Search extends Component {
  constructor(props) {
    super(props);

    this.initRequest(this.props.location);
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.location.state) { return; }

    const { product } = this.props;
    const { q, current } = this.getInitState(nextProps.location);

    if (q !== product.query || current !== parseInt(product.current, 10)) {
      const { getProductByQuery } = this.props;
      getProductByQuery(q, current);
    }
  }

  initRequest = (location) => {
    const { q, current } = this.getInitState(location);
    const { getProductByQuery } = this.props;

    getProductByQuery(decodeURI(q), current);
  }

  /**
   * get init query data
   */
  getInitState = (location) => {
    const state = location.state;
    const search = location.search.split('?')[1] || '';
    let res = {};

    if (!!state) { return state; }

    search.split('&').map((item, index) => {
      return res[item.split('=')[0]] = item.split('=')[1];
    });

    return res;
  }

  render () {
    const { product } = this.props;

    return <Step step={0} queryKey={ product.query } >
      <ProductList product={ product } query={ product.query } /> 
    </Step>
  }
}

export default connect(
  (state) => ({
    product: state.search.product
  }),
  { getProductByQuery }
)(Search);



// WEBPACK FOOTER //
// ./src/components/search/index.js